import { cn } from "@ui/lib";

const SIZES = {
	sm: { mark: "size-5", text: "text-sm" },
	md: { mark: "size-6", text: "text-base" },
	lg: { mark: "size-8", text: "text-lg" },
} as const;

/**
 * Hephon's mark: an H in a copper speech bubble, the assistant you talk to. The same drawing as
 * the favicon and app icons (apps/web/brand/mark.svg). Works alone in a collapsed sidebar.
 */
export function LogoMark({ className }: { className?: string }) {
	return (
		<svg
			viewBox="0 0 24 24"
			aria-hidden="true"
			className={cn("size-6 shrink-0", className)}
		>
			<title>Hephon</title>
			<path
				d="M7 1h10a6 6 0 0 1 6 6v6.6a6 6 0 0 1-6 6H9.6l-4.4 3.1c-.6.4-1.3-.1-1.2-.8l.4-2.9A6 6 0 0 1 1 13.6V7a6 6 0 0 1 6-6Z"
				className="fill-brand"
			/>
			<path
				d="M8.6 6.1v8.8M15.4 6.1v8.8M8.6 10.5h6.8"
				className="stroke-brand-foreground"
				strokeWidth="2.3"
				strokeLinecap="round"
				fill="none"
			/>
		</svg>
	);
}

/** "Hephon Commerce" wordmark. `withLabel={false}` renders the mark only. */
export function Logo({
	withLabel = true,
	size = "md",
	className,
}: {
	className?: string;
	withLabel?: boolean;
	size?: keyof typeof SIZES;
}) {
	return (
		<span
			className={cn(
				"inline-flex items-center gap-2 leading-none",
				SIZES[size].text,
				className,
			)}
		>
			<LogoMark className={SIZES[size].mark} />
			{withLabel ? (
				<span className="whitespace-nowrap tracking-tight">
					<span className="font-semibold text-foreground">
						Hephon
					</span>{" "}
					<span className="text-muted-foreground">Commerce</span>
				</span>
			) : (
				<span className="sr-only">Hephon Commerce</span>
			)}
		</span>
	);
}
